import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { useNavigateRoute } from "../../hooks/useNavigateRoute";
import { tokens } from "@blurb/codex-react";
import { createStyles, Menu } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import { orderColumnsV2 } from "../../configuration/columns/ordersV2.column";
import { RpaTableMenu } from "../../components/RpaTableMenu";
import React from "react";
import { RpiTableSortByProviderProps } from "../../rpi-core/table/modules/RpiTableSortBy";

type OrdersType = GraphQLPagedQueryData<GraphQL.OrdersQuery>;
const useTableStyle = createStyles({
  wrapper: {
    border: `1px solid ${tokens.color.semantic.border.faint}`,
    borderRadius: tokens.radius.lg,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
});

const useFooterStyle = createStyles({
  footer: {
    display: "flex",
    borderTop: `1px solid ${tokens.color.semantic.border.faint}`,
    backgroundColor: tokens.color.semantic.bg.surface,
  },
});

export interface OrdersTableV2Props {
  orders?: OrdersType[];
  isLoading: boolean;
  error?: unknown;
  withSortBy?: Omit<RpiTableSortByProviderProps, "children"> | undefined;
}

export function OrdersTableV2({
  orders,
  isLoading,
  error,
  withSortBy,
  children,
}: React.PropsWithChildren<OrdersTableV2Props>) {
  const { classes } = useTableStyle();

  return (
    <div className={classes.wrapper}>
      <RpiTable
        variant="normalV2"
        withSortBy={withSortBy}
        emptyMessage={"No orders found."}
        isLoading={isLoading}
        error={error}
        perPage={orders?.length}
        data={orders}
        columns={orderColumnsV2}
        additionalColumns={[
          {
            header: "",
            maxSize: 36,
            minSize: 36,
            size: 36,
            align: "center",
            noPadding: true,
            cell(data) {
              const customerPublicId = data.row.customer?.publicId;
              const customerOrderId = data.row.customerOrderId;
              if (!customerPublicId || !customerOrderId) {
                return null;
              }
              return <OrdersTableActionMenu customerPublicId={customerPublicId} customerOrderId={customerOrderId} />;
            },
          },
        ]}
      />
      {children}
    </div>
  );
}

export function OrdersTableFooter({ children }: React.PropsWithChildren) {
  const { classes } = useFooterStyle();
  return <div className={classes.footer}>{children}</div>;
}

type OrdersActionMenuProps = {
  customerPublicId: string;
  customerOrderId: string;
};
function OrdersTableActionMenu({ customerPublicId, customerOrderId }: OrdersActionMenuProps) {
  const navigateRoute = useNavigateRoute();
  return (
    <RpaTableMenu>
      <Menu.Item
        icon={<IconV3 icon="description" size={20} />}
        onClick={() => navigateRoute(["order", { customerPublicId, customerOrderId }])}
      >
        View Details
      </Menu.Item>
    </RpaTableMenu>
  );
}
